module.exports = __webpack_public_path__ + "media/images/docflix-logo-dark-be806ee7a8a87ddd68b3a3f684ef754d.png";